import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';

const PORTRAIT_SHELL_CLASS =
  'relative mx-auto overflow-hidden ' +
  'h-[300px] w-[205px] rounded-[115px] ' +
  'sm:h-[340px] sm:w-[230px] sm:rounded-[130px] ' +
  'lg:h-[380px] lg:w-[260px] lg:rounded-[145px] ' +
  'xl:h-[410px] xl:w-[285px] xl:rounded-[160px]';

function ExpertPortrait({ expert }) {
  const [src, setSrc] = useState(expert.image || '');

  return (
    <div
      className={`${PORTRAIT_SHELL_CLASS} ${expert.bgClass} transition-shadow duration-300 group-hover:shadow-[0_0_22px_rgba(138,56,245,0.35)]`}
    >
      <img
        src={src}
        alt={expert.name}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover object-top transition-[filter] duration-300 group-hover:grayscale"
        onError={() => setSrc('')}
      />
      <div
        className="pointer-events-none absolute inset-[6px] rounded-[inherit] p-[2px] opacity-0 transition-opacity duration-300 group-hover:opacity-100 sm:inset-[8px] sm:p-[3px] xl:inset-[10px]"
        style={{
          background: 'linear-gradient(180deg, #FFFFFF 0%, #8A38F5 100%)',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
        }}
        aria-hidden
      />
    </div>
  );
}

function ExpertCard({ expert }) {
  const designation = (expert.designation || expert.subject || 'Expert').trim();
  const subjectColor = expert.subjectColorCode || '#9369CC';

  const content = (
    <>
      <ExpertPortrait expert={expert} />

      <h3 className="mt-4 text-base font-bold text-white sm:text-lg">{expert.name}</h3>
      <p
        className="mt-1 text-sm font-medium text-white/80 transition-colors duration-300 group-hover:[color:var(--subject-color)]"
        style={{ '--subject-color': subjectColor }}
      >
        {designation}
      </p>
    </>
  );

  if (!expert.id) {
    return <article className="group flex flex-col items-center">{content}</article>;
  }

  return (
    <Link
      to={ROUTES.TEACHER_DETAIL(expert)}
      state={{ subjectColorCode: expert.subjectColorCode || null }}
      className="group flex flex-col items-center text-center transition hover:opacity-95"
    >
      {content}
    </Link>
  );
}

export default ExpertCard;
